import axios from "axios";
import Cookies from "universal-cookie";
import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { sedesPorInstitucionId } from "../../Services/Rest";

// Crear instancia de Axios
const axiosInstance = axios.create({
  auth: {
    username: "BasicAuth@icontec.org",
    password: "yQLzqmR7eZSuAmQZUqhY",
  },
});

function CreaEncuesta({ institucion, idSolicitud }) {
  const cookies = new Cookies();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [list, setList] = useState([]);
  const [list1, setList1] = useState([]);
  const [formData, setFormData] = useState({
    postFecha: "",
    postTipoPaciente: "",
    postTipoTrabajador: "",
    postTiempo: "",
    postServicio: "",
    postSede: "",
    postEncuesta: "",
    postTipoContrato: "",
  });

  // Función para manejar los cambios en el formulario
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Obtener datos de encuestas y sedes
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [encuestasResponse, sedesResponse] = await Promise.all([
          axiosInstance.get(
            "https://suadesarrollo.azurewebsites.net/api/ObtenerTipoEncuestas",
          ),
          axiosInstance.get(`${sedesPorInstitucionId}${institucion}`),
        ]);
        setList(encuestasResponse.data);
        setList1(sedesResponse.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [institucion]);

  // Postear datos del formulario
  const postData = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post(
        "https://suadesarrollo.azurewebsites.net/api/CreaEncuestas",
        {
          institucionId: institucion,
          solicitudId: idSolicitud,
          usuarioId: cookies.get("id"),
          fecha: formData.postFecha,
          tipoTrabajador: formData.postTipoTrabajador,
          servicio: formData.postServicio,
          tipoPaciente: formData.postTipoPaciente,
          tiempoInstitucion: formData.postTiempo,
          estado: "1",
          idTipoEncuesta: formData.postEncuesta,
          sedeId: formData.postSede,
          tipoContrato: formData.postTipoContrato,
        },
      );
      window.location.href = `/#/PresentaEncuesta/${formData.postEncuesta}/${response.data}`;
    } catch (error) {
      console.error("Error al crear:", error);
      alert("Error al crear: " + error);
    }
  };

  // Redirigir a resultados
  const postResultados = (e) => {
    e.preventDefault();
    window.location.href = `/#/InfoEncuestas/${formData.postEncuesta}/${idSolicitud}`;
  };

  return (
    <div>
      <button className="btn btn-primary" onClick={() => setIsOpen(true)}>
        Instrumentos Evaluativos
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        contentLabel="Crear Institucion"
      >
        <div className="container">
          <div className="card shadow mb-4">
            <div className="card-body">
              <form className="user">
                <div className="form-group row">
                  <div className="col-sm-6">
                    <select
                      className="btn btn-secondary btn-user btn-block"
                      name="postEncuesta"
                      onChange={handleInputChange}
                    >
                      <option value="">Seleccione tipo de encuesta</option>
                      {list.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.nombre}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-6">
                    <select
                      className="btn btn-secondary btn-user btn-block"
                      name="postSede"
                      onChange={handleInputChange}
                    >
                      <option value="">Seleccione la sede</option>
                      <option value={institucion}>No tiene</option>
                      {list1.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.nombre}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Condicionales de Encuestas */}
                {formData.postEncuesta == 2 && (
                  <div className="form-group row">
                    <input
                      type="date"
                      className="form-control form-control-user"
                      name="postFecha"
                      onChange={handleInputChange}
                    />
                    {/* Otros campos para Encuesta 2 */}
                  </div>
                )}
                {/* Añadir más condicionales según sea necesario */}

                <button
                  className="btn btn-primary btn-user btn-block"
                  onClick={postData}
                >
                  Iniciar Encuesta
                </button>
                <button
                  className="btn btn-warning btn-user btn-block"
                  onClick={postResultados}
                >
                  Ver Resultados
                </button>
              </form>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CreaEncuesta;
